export default __webpack_public_path__ + "static/media/pak7.9d581ea1.jpg";